
// src/app/core/services/socket.service.ts

import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { io, Socket } from 'socket.io-client';
import { SessionEvent } from '../../typings/session.types';

@Injectable({ providedIn: 'root' })
export class SocketService {
  public socket!: Socket;

  connect(): void {
    if (this.socket) {
      this.socket.disconnect();
    }

    this.socket = io(environment.apiBase, {
      transports: ['websocket'],
    });

    this.socket.on('connect', () => {
      console.log('🟢 Socket.IO connected:', this.socket.id);
    });
  }

  onSessionCreated(callback: (session: SessionEvent) => void): void {
    if (!this.socket) this.connect();
    this.socket.on('session_created', callback);
  }

  onSessionClosed(callback: (session: SessionEvent) => void): void {
    if (!this.socket) this.connect();
    this.socket.on('session_closed', callback);
  }

  onNotification(callback: (notification: any) => void): void {
    if (!this.socket) this.connect();
    this.socket.on('new_notification', callback);
  }

  disconnect(): void {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = undefined!;
    }
  }
}
